import { render, staticRenderFns } from "./FixClientPopup.vue?vue&type=template&id=94c17164&scoped=true"
import script from "./FixClientPopup.vue?vue&type=script&lang=js"
export * from "./FixClientPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c17164",
  null
  
)

export default component.exports